import React from "react"
import VideoPage from "../components/video-page"

const Tentakulum2Page = () => (
  <VideoPage title="TENTAKULUM 2" path="/video/tentakulum-2.{ext}" />
)

export default Tentakulum2Page
